export interface MetaData {
  title?: string;
  description?: string;
  keywords?: string[] | string;
  author?: string;
  [key: string]: string | string[] | undefined;
}

export class MetaManager {
  static setTitle(title: string) {
    document.title = title;
    let titleTag = document.querySelector("title");
    if (!titleTag) {
      titleTag = document.createElement("title");
      document.head.appendChild(titleTag);
    }
    titleTag.textContent = title;
  }

  static async fetchMetaData(url: string): Promise<MetaData> {
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok) {
      throw new Error(`Failed to load meta JSON: ${response.statusText}`);
    }
    return (await response.json()) as MetaData;
  }

  static setMetaTag(meta: MetaData) {
    const head = document.head;

    // Set document title if specified
    if (meta.title) {
      document.title = meta.title;
    }

    // Helper to create and add a meta tag
    function addMetaTag(
      attrName: "name" | "property",
      attrValue: string,
      content: string
    ) {
      const tag = document.createElement("meta");
      tag.setAttribute(attrName, attrValue);
      tag.setAttribute("content", content);
      tag.setAttribute("data-generated-meta", "true"); // mark as dynamic
      head.appendChild(tag);
    }

    // Iterate keys in meta object
    Object.entries(meta).forEach(([key, value]) => {
      if (!value || key === "title") return; // skip title handled separately

      const content = Array.isArray(value) ? value.join(", ") : value;

      // Open Graph properties normally start with 'og:' and use property attr
      if (key.startsWith("og:") || key.startsWith("twitter:")) {
        addMetaTag("property", key, content);
      } else {
        addMetaTag("name", key, content);
      }
    });
  }
}
